var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingListOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0a1 1 0 100 2h2.124L5.01 16.132A1 1 0 006 17h14a1 1 0 00.98-.804l2-10A1 1 0 0022 5h-1.586l-3.707-3.707a1 1 0 00-1.414 0L13.5 3.086l-1.793-1.793a1 1 0 00-1.414 0L6.586 5H5.542L4.992.868A1 1 0 004 0H1zm8.414 5h3.172L11 3.414 9.414 5zm6 0h2.172L16 3.414 14.914 4.5l.5.5zM6.876 15L5.809 7H20.78l-1.6 8H6.876zM7 18a3 3 0 100 6 3 3 0 000-6zm-1 3a1 1 0 112 0 1 1 0 01-2 0zM16 21a3 3 0 116 0 3 3 0 01-6 0zm3-1a1 1 0 100 2 1 1 0 000-2z"
  })));
}
export default SvgShoppingListOutline;